import gql from 'graphql-tag'

export const LIST_INTEGRATIONS = gql`
  query listIntegrations($merchant_id: uuid!, $provider: String) {
    listIntegrations(merchant_id: $merchant_id, provider: $provider) {
      id
      webhook_token
      location_ids
    }
  }
`

export const VALIDATE_INTEGRATION = gql`
  mutation ValidateIntegration(
    $merchant_id: uuid!
    $provider: String!
    $api_key: String!
  ) {
    validateIntegration(
      merchant_id: $merchant_id
      provider: $provider
      api_key: $api_key
    ) {
      webhook_url
      webhook_token
    }
  }
`

export const SAVE_INTEGRATION = gql`
  mutation SaveIntegration(
    $merchant_id: uuid!
    $provider: String!
    $api_key: String!
    $location_ids: [uuid!]
  ) {
    saveIntegration(
      merchant_id: $merchant_id
      provider: $provider
      api_key: $api_key
      location_ids: $location_ids
    ) {
      id
      webhook_token
      location_ids
    }
  }
`

export const UPDATE_INTEGRATION = gql`
  mutation UpdateIntegration(
    $merchant_id: uuid!
    $integration_id: uuid!
    $api_key: String
    $location_ids: [uuid!]
  ) {
    updateIntegration(
      merchant_id: $merchant_id
      integration_id: $integration_id
      api_key: $api_key
      location_ids: $location_ids
    ) {
      id
      webhook_token
      location_ids
    }
  }
`

export const DISCONNECT_INTEGRATION = gql`
  mutation DisconnectIntegration($merchant_id: uuid!, $integration_id: uuid!) {
    disconnectIntegration(
      merchant_id: $merchant_id
      integration_id: $integration_id
    )
  }
`
